module.exports = __webpack_public_path__ + "static/media/blip3.2c193f64.mp3";